<template>
    <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark bg-cflow" id="sidenav-main">
        <div class="container-fluid">

            <!--Toggler-->
            <navbar-toggle-button @click.native="showSidebar">
                <span class="navbar-toggler-icon"></span>
            </navbar-toggle-button>
            <router-link class="navbar-brand" to="/">
                <img :src="logo" class="navbar-brand-img" alt="...">
            </router-link>

            <slot name="mobile-right">
                <ul class="nav align-items-center d-md-none">
                    <base-dropdown class="nav-item" position="right">
                        <a slot="title" class="nav-link" href="#" role="button">
                            <div class="media align-items-center">
                              <span class="avatar avatar-lg rounded-circle">
                                 <img :alt="info_usuario.nome" :src="info_usuario.avatar">
                              </span>
                            </div>
                        </a>

                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Bem vindo(a)!</h6>
                        </div>
                        <!-- <router-link to="/conta" class="dropdown-item">
                            <i class="ni ni-single-02"></i>
                            <span>Minha conta</span>
                        </router-link> -->
                        <div class="dropdown-divider"></div>
                         <router-link to="/alterar-senha" class="clickable dropdown-item">
                          <i class="fas fa-key"></i>
                            <span>Alterar Senha</span>
                          </router-link>
                        <div class="clickable dropdown-item" @click="logoff()">
                            <i class="fas fa-sign-out-alt"></i>
                            <span>Deslogar</span>
                        </div>
                    </base-dropdown>
                </ul>
            </slot>
            <slot></slot>
            <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

                <div class="navbar-collapse-header d-md-none">
                    <div class="row">
                        <div class="col- collapse-close">
                            <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
                        </div>
                    </div>
                </div>

                <ul class="navbar-nav">
                    <slot name="links">
                    </slot>
                </ul>

            </div>
            </div>
    </nav>
</template>
<script>
  import NavbarToggleButton from '@/components/NavbarToggleButton'
  import storage from 'storage'
  import usuario from "@/cflow/usuario.js";
  import router from '@/router'

  export default {
    name: 'sidebar',
    components: {
      NavbarToggleButton
    },
    props: {
      logo: {
        type: String,
        default: '../../img/brand/logo.png',
        description: 'Conect Flow'
      },
      autoClose: {
        type: Boolean,
        default: true,
        description: 'Whether sidebar should autoclose on mobile when clicking an item'
      }
    },
    provide() {
      return {
        autoClose: this.autoClose
      };
    },
    methods: {
      closeSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      showSidebar() {
        this.$sidebar.displaySidebar(true)
      },
      logoff(){
        usuario.logoff();
        router.push('/login');
      }
    },
    data() {
      return {
        info_usuario:{
          nome: storage.get("user","nome"),
          avatar: storage.get("user","avatar")
        }
      }
    },
    mounted(){
      this.usuario = storage.get('user')
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false;
      }
    }
  };
</script>
